import { render, staticRenderFns } from "./InitiativeList.vue?vue&type=template&id=184ccd12&scoped=true&"
import script from "./InitiativeList.vue?vue&type=script&lang=js&"
export * from "./InitiativeList.vue?vue&type=script&lang=js&"
import style0 from "./InitiativeList.vue?vue&type=style&index=0&id=184ccd12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184ccd12",
  null
  
)

export default component.exports